// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3RjE0","requiredAsterisk":"Info_requiredAsterisk__1qLex"};